import { DEFAULT_ASSEMBLY_COMPONENT_CONFIG } from 'src/constants';

import { getAssetUrl } from './environment';

export enum Extensions {
  MP4 = 'mp4',
  WEBM = 'webm',
  JPEG = 'jpeg',
  JPG = 'jpg',
  PNG = 'png',
  GIF = 'gif',
  ZIP = 'zip',
}

export enum FileTypes {
  VIDEO = 'video',
  IMAGE = 'image',
}

export const getFileExtensionType = (src: string | undefined) => {
  if (!src) return null;
  try {
    const extension = src.split('.').reverse()[0];

    switch (extension) {
      case Extensions.MP4:
      case Extensions.WEBM:
        return FileTypes.VIDEO;

      case Extensions.JPEG:
      case Extensions.JPG:
      case Extensions.PNG:
      case Extensions.GIF:
        return FileTypes.IMAGE;

      default:
        return null;
    }
  } catch (err) {
    return null;
  }
};

export const getVideoDurationFromUrl = (url: string): Promise<number> => {
  return new Promise((resolve, reject) => {
    const video = document.createElement('video');
    video.preload = 'metadata';
    video.src = getAssetUrl(`/file/${url}`);

    video.onloadedmetadata = () => {
      resolve(video.duration);
    };

    video.onerror = () => {
      reject(new Error('Failed to load video metadata from URL.'));
    };
  });
};

export const getBackgroundVideoDuration = async (
  componentUrl?: string,
  defaultDuration = DEFAULT_ASSEMBLY_COMPONENT_CONFIG.duration,
  multiplier = 1,
) => {
  let updatedDuration = defaultDuration;
  if (componentUrl) {
    const componentBackgroundType = getFileExtensionType(componentUrl);
    if (componentBackgroundType === FileTypes.VIDEO) {
      try {
        updatedDuration =
          (await getVideoDurationFromUrl(componentUrl)) * multiplier;
      } catch (error) {
        console.error('Error fetching video duration:', error);
      }
    }
  }

  /* The DB only allows the duration to be an integer */
  return Math.round(updatedDuration);
};
